// src/pages/ChatDocuments/positioning.ts
import type { Side, Align } from "./chatTypes";

export type ComputePosFn = (
  anchor: HTMLElement,
  panelW: number,
  panelH: number,
  opts?: { gap?: number; preferSide?: Side; preferAlign?: Align }
) => { position: "fixed"; left: number; top: number };

export const computeAutoPosition: ComputePosFn = (
  anchor,
  panelW,
  panelH,
  opts
) => {
  const gap = opts?.gap ?? 8;
  const preferSide = opts?.preferSide ?? "bottom";
  const preferAlign = opts?.preferAlign ?? "start";

  const r = anchor.getBoundingClientRect();
  const vw = window.innerWidth;
  const vh = window.innerHeight;

  const spaceBelow = vh - r.bottom - gap;
  const spaceAbove = r.top - gap;
  const side: Side =
    (preferSide === "bottom" && spaceBelow >= panelH) || spaceBelow >= spaceAbove
      ? "bottom"
      : "top";

  const leftStart = r.left;
  const leftEnd = r.right - panelW;
  const fitsStart = leftStart + panelW <= vw - gap;
  const fitsEnd = leftEnd >= gap;

  let align: Align = preferAlign;
  if (align === "start" && !fitsStart && fitsEnd) align = "end";
  if (align === "end" && !fitsEnd && fitsStart) align = "start";
  if (!fitsStart && !fitsEnd) {
    const left = Math.min(Math.max(gap, r.left), Math.max(gap, vw - panelW - gap));
    const top = side === "bottom" ? r.bottom + gap : r.top - panelH - gap;
    return { position: "fixed", left, top };
  }

  const left = align === "start" ? leftStart : leftEnd;
  const top = side === "bottom" ? r.bottom + gap : r.top - panelH - gap;
  return { position: "fixed", left, top };
};
